module.exports = __webpack_public_path__ + "static/media/locked.4c186d50.png";